// extracted by mini-css-extract-plugin
export default {"row":"ShareFlagToggle_row__vuJTD"};